import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface RAGSettings {
  // Search Logic
  semanticWeight: number;    // 0-1, default 0.7
  lexicalWeight: number;     // 0-1, default 0.3

  // Context Control
  topK: number;              // 1-20, default 10
  confidenceThreshold: number; // 0-1, default 0.8

  // Generation Style
  temperature: number;       // 0-1, default 0.3
  maxTokens: number;         // 256-4096, default 2048

  // Troubleshooting
  maxDiagnosticTurns: number; // 1-10, default 5
}

interface SettingsState {
  settings: RAGSettings;
  updateSettings: (updates: Partial<RAGSettings>) => void;
  resetToDefaults: () => void;
}

const DEFAULT_SETTINGS: RAGSettings = {
  semanticWeight: 0.7,
  lexicalWeight: 0.3,
  topK: 10,
  confidenceThreshold: 0.8,
  temperature: 0.3,
  maxTokens: 2048,
  maxDiagnosticTurns: 5,
};

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      settings: DEFAULT_SETTINGS,

      updateSettings: (updates) =>
        set((state) => ({
          settings: { ...state.settings, ...updates },
        })),

      resetToDefaults: () =>
        set({ settings: DEFAULT_SETTINGS }),
    }),
    {
      name: 'linerdocs-settings',
    }
  )
);

export { DEFAULT_SETTINGS };
